import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-menu-safe-job',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './menu-safe-job.component.html',
  styleUrl: './menu-safe-job.component.css'
})
export class MenuSafeJobComponent {

}
